'use client';

import { useEffect } from 'react';

/**
 * Root error boundary. Rendered when a server or client component throws.
 * Logs the error for debugging and keeps the failure recoverable instead of
 * the raw "Application error: a server-side exception has occurred" screen.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[GlobalError boundary]', error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-xl font-bold text-foreground">Something went wrong.</h1>
      <p className="text-sm text-muted-foreground max-w-sm">
        We could not load this page. Your data is safe — please try again.
      </p>
      {error?.message && (
        <p className="text-2xs text-muted-foreground/70 max-w-md font-mono break-all">
          {error.message}
        </p>
      )}
      <button onClick={reset} className="btn-primary">
        Try again
      </button>
    </div>
  );
}
